import projectsTable from '../../../modules/projects/projects.table';
import projectTable from '../../../modules/projects/project.table';
import projectTypesTable from './project-types.table';
import stagesTable from './stages.table';
import featuresTable from './features.table';
import plansTable from './plans.table';
import contactsTable from './contacts.table';
import estimatesTable from './estimates.table';
import timesheetsTable from './timesheets.table';
import expensesTable from './expenses.table';
import rolesTable from './roles.table';
import usersTable from './users.table';

export default {
  namespaced: true,
  state: {
    projectTable,
    projectsTable,
    projectTypesTable,
    stagesTable,
    featuresTable,
    plansTable,
    contactsTable,
    estimatesTable,
    timesheetsTable,
    expensesTable,
    rolesTable,
    usersTable,
  },
  getters: {},
  mutations: {},
  actions: {},
};
